import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import PaginateList from "../../../utils/PaginateList";
import * as CodeServices from "../../../../services/CodeService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
} from "./codeList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import {} from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const CodeListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);

  const columns = [
    {
      header: t("forms.code.table.heads.code"),
      accessorKey: "code",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.code.table.heads.vivero"),
      accessorKey: "vivero.name",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.code.table.heads.batch"),
      accessorKey: "batch.code",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.code.table.heads.culture"),
      accessorKey: "culture",
      cell: (info) => t(info.getValue()),
    },
    {
      header: t("forms.code.table.heads.variety"),
      accessorKey: "variety.name",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.code.table.heads.article"),
      accessorKey: "article.code",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.code.table.heads.location"),
      accessorKey: "location.name",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.code.table.heads.sector"),
      accessorKey: "sector.name",
      cell: (info) => {
        if (info.getValue()) {
          return info.getValue();
        }

        return "-";
      },
    },
    {
      header: t("forms.code.table.heads.status"),
      accessorKey: "status",
      cell: (info) => {
        if (info.getValue() === "ACTIVE") {
          return t("active");
        }

        return t("disabled");
      },
    },
    {
      Header: t(" "),
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const goToEdit = (uuid) => {
    navigate(`/user/code/form/update/${uuid}`);
  };

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction onClick={() => goToEdit(data.uuid)} type="button">
          <i className="fa-regular fa-pen-to-square"></i>
        </ButtonAction>
        <ButtonAction
          onClick={() => showDialogOnDelete(data.uuid)}
          type="button"
        >
          <Icon className="fa-solid fa-trash-can"></Icon>
        </ButtonAction>
      </div>
    );
  };

  const showDialogOnDelete = (uuid) => {
    const okAction = async () => {
      CodeServices.deleteCode(uuid).then((result) => {
        if (result && result.deleted === true) {
          setForceRefresh(true);
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.code.dialog.remove.title"),
      t("forms.code.dialog.remove.text"),
      "warning",
      true,
      t("forms.code.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.code.dialog.remove.buttonNo"),
      cancelAction
    );
  };

  const listData = async (filter) => {
    // if (sortBy) {
    //   filter.sort = sortBy;
    // } else {
    //   filter.sort = '-date';
    // }
    const result = await CodeServices.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <PaginateList
      refresh={forceRefresh}
      filters={filters}
      columns={columns}
      toList={listData}
      hideColum={hideColumn}
      resize={resize}
      resetRefresh={() => setForceRefresh(false)}
    ></PaginateList>
  );
};

CodeListContainer.propTypes = {
  filters: PropTypes.object,
};

export default CodeListContainer;
